import CustomTableList from './CustomTableList';
import utils from '../utils/utils';
import { COUNTRY_TITLE } from '../utils/constants';

class CountryList extends CustomTableList {
    ShowTitle = () => utils.getPlural(COUNTRY_TITLE);

    customHandled() {
        return false;
    }
}

export default CountryList;
